import { Avatar } from "@mui/material";
import { Datagrid, FunctionField, TextField, useTranslate } from "react-admin";

import { PatientRecord } from "../types/patient";
import { GenderField } from "./fields/GenderField";
import { LocalizedDateField } from "./fields/LocalizedDateField";
import { SourceSystemChip } from "./fields/SourceSystemChip";

interface PatientDataGridProps {
  showLocationColumn?: boolean;
}

export const PatientDataGrid = ({ showLocationColumn = true }: PatientDataGridProps) => {
  const translate = useTranslate();

  return (
    <Datagrid rowClick={"show"} bulkActionButtons={false}>
      <FunctionField
        label="Avatar"
        render={(record: PatientRecord) => <Avatar src={record?.avatarUrl || undefined} alt={record.name} />}
      />
      <TextField source="firstName" sortable={false} label="Vorname" />
      <TextField source="lastName" sortable={false} label="Nachname" />
      <TextField source="patientNumber" sortable={false} label="Bewohner-ID" />
      <FunctionField
        label="Quelle"
        render={(record: PatientRecord) => (
          <SourceSystemChip record={record} translatePrefix="Patient.fields.sourceSystem" />
        )}
      />
      <GenderField sortable={false} label="Geschlecht" />
      <LocalizedDateField source="birthDate" sortable={false} label="Geburtsdatum" />
      {showLocationColumn && (
        <FunctionField
          label={translate("location")}
          sortable={false}
          render={(record: PatientRecord) => {
            if (!record.locationHierarchy?.length) return null;
            // Show the 2 most general locations (e.g., "Site > Department" or "Site > Ward")
            const locations = [...record.locationHierarchy]
              .sort((a, b) => b.level - a.level)
              .slice(0, 2)
              .map(l => l.locationName)
              .join(" > ");
            return locations;
          }}
        />
      )}
    </Datagrid>
  );
};
